export const receiveGoogleScopes = (scopes) => {
  return {
    type: 'RECIEVE_GOOGLE_SCOPES',
    scopes,
  }
}
